import {
  MarketplaceGeneralSettingsResponse,
  MarketplaceGeneralSettingsUpdateRequest,
  SupportedCustomerType,
} from 'APIs/marketplaces/marketplaces.general.settings.types';
import { supportedCustomerTypes } from 'Constants/Constants';

export type GeneralSettingsUpdateFormProps = {
  supportedCustomerTypes: Array<{ value: SupportedCustomerType; label: string }>;
};

type ToMarketplaceGeneralSettingsUpdateRequest = (
  generalSettings: MarketplaceGeneralSettingsResponse | null,
  formData: GeneralSettingsUpdateFormProps,
) => MarketplaceGeneralSettingsUpdateRequest | null;

type ToGeneralSettingsUpdateFormProps = (
  generalSettings: MarketplaceGeneralSettingsResponse,
) => GeneralSettingsUpdateFormProps;

export const toMarketplaceGeneralSettingsUpdateRequest: ToMarketplaceGeneralSettingsUpdateRequest = (
  generalSettings: MarketplaceGeneralSettingsResponse | null,
  formData: GeneralSettingsUpdateFormProps,
): MarketplaceGeneralSettingsUpdateRequest | null => {
  return generalSettings && formData
    ? { ...generalSettings, supportedCustomerTypes: formData.supportedCustomerTypes.map((r) => r.value) }
    : null;
};

export const toGeneralSettingsUpdateFormProps: ToGeneralSettingsUpdateFormProps = (
  generalSettings: MarketplaceGeneralSettingsResponse,
): GeneralSettingsUpdateFormProps => {
  return {
    supportedCustomerTypes: supportedCustomerTypes.filter((ct) =>
      generalSettings.supportedCustomerTypes.includes(ct.value),
    ),
  };
};
